// FOTOGRAFÍAS REALES de Wild Spoon / Edu Vincent (prohibido sustituirlas por stock o generarlas por IA).
// Viven en /app/frontend/public/photos/. Añadir más reales en GALLERY con { url, cat, cap: {es,en,fr} }.
// DECISIÓN: no se usan imágenes que sugieran cenas con vistas a la Alhambra (la terraza no es un espacio privado de servicio).

export const IMAGES = {
  hero: "/photos/edouard-interior.jpg",
  edouardPortrait: "/photos/edouard-terraza.jpg",
  philoMain: "/photos/cocina-caldo-rojo.jpg",
  philoVideo: "/photos/cocina-paella.mp4",
  philoWide: "/photos/arroz-ternera.jpg",
  expEdouard: "/photos/pastilla-cordero.jpg",
  expHome: "/photos/plato-salmon.jpg",
};

export const GALLERY = [
  {
    cat: "platos",
    url: "/photos/arroz-ternera.jpg",
    cap: { es: "Un arroz para compartir, en el centro de la mesa.", en: "A rice dish made for sharing, right from the middle of the table.", fr: "Un riz à partager, au centre de la table." },
  },
  {
    cat: "platos",
    url: "/photos/plato-salmon.jpg",
    cap: { es: "Platos bellos y cuidados, nunca tímidos.", en: "Beautiful, careful plates — never shy.", fr: "Des assiettes belles et soignées, jamais timides." },
  },
  {
    cat: "platos",
    url: "/photos/plato-gambas.jpg",
    cap: { es: "Que cada bocado tenga algo que contar.", en: "Every bite has something to say.", fr: "Chaque bouchée a quelque chose à raconter." },
  },
  {
    cat: "platos",
    url: "/photos/rollo-naranja.jpg",
    cap: { es: "Texturas trabajadas, detalles inesperados.", en: "Reworked textures, unexpected details.", fr: "Textures retravaillées, détails inattendus." },
  },
  {
    cat: "platos",
    url: "/photos/pollo-verduras.jpg",
    cap: { es: "Producto, salsas profundas y un detalle inesperado.", en: "Produce, deep sauces and an unexpected detail.", fr: "Produit, sauces profondes et un détail inattendu." },
  },
  {
    cat: "platos",
    url: "/photos/pastilla-cordero.jpg",
    cap: { es: "Pastilla de cordero con batata.", en: "Lamb pastilla with sweet potato.", fr: "Pastilla d'agneau à la patate douce." },
  },
  {
    cat: "platos",
    url: "/photos/cocina-crema-naranja.jpg",
    cap: { es: "Cocciones lentas, sabores francos.", en: "Slow cooking, honest flavours.", fr: "Cuissons lentes, goûts francs." },
  },
  {
    cat: "postres",
    url: "/photos/postre-merengue.jpg",
    cap: { es: "Un final luminoso, con acidez y crujiente.", en: "A bright ending — acidity and crunch.", fr: "Une fin lumineuse, acidité et croquant." },
  },
  {
    cat: "platos",
    url: "/photos/wonton-crujiente.jpg",
    cap: { es: "El crujiente también es elegancia.", en: "Crunch is part of elegance too.", fr: "Le croquant fait aussi partie de l'élégance." },
  },
  {
    cat: "postres",
    url: "/photos/postre-chocolate-bol.jpg",
    cap: { es: "Un final dulce con carácter.", en: "A sweet ending with character.", fr: "Une fin douce avec du caractère." },
  },
  {
    cat: "postres",
    url: "/photos/postre-mousse.jpg",
    cap: { es: "La generosidad también es elegancia.", en: "Generosity is part of elegance.", fr: "La générosité fait partie de l'élégance." },
  },
  {
    cat: "cocina",
    url: "/photos/cocina-caldo-rojo.jpg",
    cap: { es: "Fuego, calma y salsas profundas.", en: "Fire, patience and deep sauces.", fr: "Le feu, la patience et les sauces profondes." },
  },
  {
    cat: "cocina",
    url: "/photos/cocina-fuego-bunuelos.jpg",
    cap: { es: "El fuego vivo en la cocina.", en: "Live fire in the kitchen.", fr: "Le feu vif dans la cuisine." },
  },
  {
    cat: "edouard",
    url: "/photos/edouard-interior.jpg",
    cap: { es: "Edu, en su casa del Albaicín.", en: "Edu, at his home in the Albaicín.", fr: "Edu, chez lui dans l'Albaicín." },
  },
  {
    cat: "edouard",
    url: "/photos/edouard-terraza.jpg",
    cap: { es: "Edu, en la terraza de su casa.", en: "Edu, on the terrace of his home.", fr: "Edu, sur la terrasse de sa maison." },
  },
];

export const GALLERY_CATS = ["platos", "postres", "cocina", "edouard"];
